module.exports = __webpack_public_path__ + "static/media/Hotel-Seeleiten.1dcb1b25.png";